<template>
    <div>
        <div class="solutionguide__result-product" v-if="displayObject" :class="displayObject.isFallback ? 'solutionguide__result-product--fallback' : ''">
            <a v-if="displayObject.src && displayObject.detail_link" :href="displayObject.detail_link" target="_blank">
                <img :src="displayObject.src" alt="" :title="displayObject.title" class="solutionguide__result-product-img" />
            </a>
            <img v-else-if="displayObject.src" :src="displayObject.src" alt="" :title="displayObject.title" class="solutionguide__result-product-img" />
            <div>
                <component :is="displayObject.detail_link ? 'a' : 'p'" :href="displayObject.detail_link" target="_blank">
                    <span v-if="displayObject.title"><strong>{{displayObject.title}}</strong></span><br v-if="displayObject.title && displayObject.subtitle" />
                    <span v-if="displayObject.subtitle">{{displayObject.subtitle}}</span>
                </component>
                <div v-if="showButtonAside && displayObject && (!displayObject.isIndividual || displayObject.isFallback)" class="button-wrapper spacer--top-small">
                    <global-button v-if="displayObject.isFallback" theme="primary" @click="openModal">{{ $t('result.row.decor.select') }}</global-button>
                    <global-button v-else theme="secondary" @click="openModal">{{ $t('result.row.decor.change') }}</global-button>
                    <decorfinder v-if="showModal" displayMode="modal" :baseProducts="[product]" @close="onModalClose" @save="onModalSave" />
                </div>
            </div>
        </div>
        <div v-if="!showButtonAside && displayObject && (!displayObject.isIndividual || displayObject.isFallback)" class="button-wrapper spacer--top-small">
            <global-button v-if="displayObject.isFallback" theme="primary" @click="openModal">{{ $t('result.row.decor.select') }}</global-button>
            <global-button v-else theme="secondary" @click="openModal">{{ $t('result.row.decor.change') }}</global-button>
            <decorfinder v-if="showModal" displayMode="modal" :baseProducts="[product]" @close="onModalClose" @save="onModalSave" />
        </div>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import StepWrapper from "./step-wrapper.vue";
import GlobalButton from "../../../../../global/global-elements/global-button/global-button.vue";
import Decorfinder from "./decorfinder.vue";
import {Productfinder} from "../../../../../_types/productfinder";
import {SolutionGuide} from "../../../../../_types/solutionguide";
import {individualPropertyId, isIndividualProduct} from "../store/solutionGuideGetters";
import {mapGetters, mapState} from "vuex";

interface DisplayObject {
    src: string
    title: string
    subtitle: string
    detail_link?: string
    isFallback: boolean
    isIndividual: boolean
}

export default Vue.extend({
    name: "result-table-row-decor",
    components: {Decorfinder, GlobalButton, StepWrapper},
    props: {
        component: {
            type: Object as () => SolutionGuide.Component,
            required: true
        },
        product: {
            type: Object as () => SolutionGuide.DekorativePlatte,
            required: true
        }
    },
    data() {
        return {
            showModal: false
        }
    },
    computed: {
        ...mapState(['result', 'activeBreakpoint']),
        ...mapGetters(['getSelectedDecor']),
        displayObject(): DisplayObject | null {

            const selectedDecor = this.getSelectedDecor(this.component.name + '#' + this.product.pim_id) as Productfinder.Product | undefined
            if (selectedDecor) {
                return {
                    src: selectedDecor.image_src,
                    title: selectedDecor.title,
                    subtitle: selectedDecor.subtitle || '',
                    detail_link: selectedDecor.detail_link,
                    isFallback: false,
                    isIndividual: false,
                }
            }

            if (isIndividualProduct(this.product)) {
                const property = this.$store.state.segment.propertyMap[individualPropertyId];

                return {
                    src: property.icon,
                    title: this.$t("result.row.decor.individual").toString(),
                    subtitle: '',
                    isFallback: false,
                    isIndividual: true
                }
            }

            // Fallback to same decor as the selected component
            if (isIndividualProduct(this.$store.state.result)) {
                const property = this.$store.state.segment.propertyMap[individualPropertyId];

                return {
                    src: property.icon,
                    title: this.$t("result.row.decor.fallback").toString(),
                    subtitle: '',
                    isFallback: true,
                    isIndividual: true
                }
            }

            const selectedResultDecor = this.getSelectedDecor(this.$store.state.component.name + '#' + this.$store.state.result.pim_id) as Productfinder.Product | undefined
            if (selectedResultDecor) {
                const isFallback = this.product.pim_id !== selectedResultDecor.pim_id && !this.product.decors.includes(selectedResultDecor.type + selectedResultDecor.pim_id);

                return {
                    src: selectedResultDecor.image_src,
                    title: isFallback ? '' : selectedResultDecor.title,
                    subtitle: isFallback ? this.$t('result.row.decor.fallback').toString() : selectedResultDecor.subtitle || '',
                    detail_link: isFallback ? undefined : selectedResultDecor.detail_link,
                    isFallback: isFallback,
                    isIndividual: false
                }
            }

            return null
        },
        showButtonAside(): boolean {
            return this.activeBreakpoint === 'lg' || this.activeBreakpoint === 'xl'
        }
    },
    methods: {
        openModal() {
            this.showModal = true;
        },
        onModalClose() {
            this.showModal = false
        },
        onModalSave(decor: Productfinder.Product | null): void {
            if (decor) {
                this.$store.commit('selectDecor', { key: this.component.name + '#' + this.product.pim_id, decor: decor})
            }
            else {
                this.$store.commit('selectDecor', { component: this.component.name + '#' + this.product.pim_id, decor: null})
            }
            this.showModal = false
        }
    }
})
</script>
